import { useState } from 'react';

export default function useHandleModal() {
    const [open, setOpen] = useState(false);
    const [periodTime, setPeriodTime] = useState({
        start: null,
        end: null
    });
    const [typePeriod, setTypePeriod] = useState();
    const [dayOfWeek , setDayOfWeek] = useState();

    const handleOpenModal = () => {
        setOpen(true);
    };

    const handleCloseModal = () => {
        setOpen(false);
    };

    return {
        open,
        handleOpenModal,
        handleCloseModal,
        periodTime,
        setPeriodTime,
        typePeriod,
        setTypePeriod,
        dayOfWeek,
        setDayOfWeek
    }
}